import "./GarageDoorSpringReplacementSydney.module.css";
import Header from "@/reusable_sections/Header";
import GarageHero from "./sections/GarageHero";
import GarageIntegrity from "./sections/GarageIntegrity";
import SpringIssues from "./sections/SpringIssues";
import GarageProcess from "./sections/GarageProcess";
import WhyChooseSpring from "./sections/WhyChooseSpring";
import Pricing from "./sections/Pricing";
import GarageServices from "./sections/GarageServices";
import GarageFaq from "./sections/GarageFaq";
import GarageCta from "./sections/GarageCta";
import ServiceAreas from "./sections/ServiceAreas";
import GarageService from "./sections/GarageService";
export default function GarageDoorSpringReplacementSydneyPage() {
  return <div>
      <Header />
      <GarageHero />
      <GarageCta />
      <GarageIntegrity />
      <SpringIssues />
      <GarageProcess />
      <WhyChooseSpring />
      <Pricing />
      <GarageServices />
      <GarageService />
      <ServiceAreas />
      <GarageFaq />
    </div>;
}